import React, { useEffect } from "react";
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import * as colors from "@mui/material/colors";
import CssBaseline from "@mui/material/CssBaseline";

const themeConfig = {
  palette: {
    mode: "light",
    primary: {
      main: "#3F3F3F",
    },
    secondary: {
      main: colors.pink["500"],
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
  },
  common: {
    typography: {
      fontSize: 14,
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1200,
        xl: 1920,
      },
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          "#__next": {
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            "& > *": {
              flexShrink: 0,
            },
          },
        },
      },
    },
  },
};
function getTheme() {
  const baseTheme = {
    palette: themeConfig.palette,
    typography: themeConfig.common.typography,
    breakpoints: themeConfig.common.breakpoints,
    Components: {
      MuiCssBaseline: {
        styleOverrides: {
          '@global': themeConfig.common.overrides.MuiCssBaseline['@global'],
        },
      },
    },
  };

  return createTheme(baseTheme);
}

export const ThemeProvider = (props) => {


  const theme = getTheme();

  useEffect(() => {
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        {/* Set global MUI styles */}
        <CssBaseline />
        {props.children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};